module.exports = __webpack_public_path__ + "static/media/geannuleerd.62294751.svg";